import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const news = handleActions(
  {
    [actionTypes.NEWS_REQUEST]: () => [],
    [actionTypes.NEWS_SUCCESS]: (state, { payload }) => payload.items,
    [actionTypes.NEWS_FAILURE]: () => [],
  },
  [],
);

export const isLoading = handleActions(
  {
    [combineActions(actionTypes.NEWS_SUCCESS, actionTypes.NEWS_FAILURE)]: () => false,
    [actionTypes.NEWS_REQUEST]: () => true,
  },
  false,
);

export default combineReducers({
  news,
  isLoading,
});
